<template>
  <div>
    <div class="bg-primary h-48">
      <router-link :to="{name:'scf'}" class="font-bold" style="margin: 0 20px; line-height: 48px;" v-show="home">
        <a-icon type="home"/>
        返回首页
      </router-link>
      <a-dropdown v-if="isLogin">
        <span @click="e => e.preventDefault()"
              style="color:white; float:right; line-height:48px;margin: 0 20px">
      {{ name }}<a-icon type="down"/>
    </span>
        <a-menu slot="overlay" @click="onLogout">
          <a-menu-item key="1">
            <router-link :to="toCenter">
              个人中心
            </router-link>

          </a-menu-item>
          <a-menu-item key="2">
            退出
          </a-menu-item>
        </a-menu>
      </a-dropdown>

      <template v-else>
        <router-link :to="{name:'register'}" href="" class="float-right" style="margin-right: 20px; line-height: 48px;">
          注册
        </router-link>
        <router-link :to="{name:'login'}" class="float-right" style="margin-right:20px; line-height: 48px;">
          登录
        </router-link>
      </template>


    </div>

    <!--    logo&search-->
    <a-row type="flex" align="middle" style="min-height:120px">
      <a-col :span="24" :sm="24" :md="24" :lg="12">
        <div class="logo d-inline-block">
        <table><tbody><tr><td><img src="/static/imgs/logo.png" alt="沈阳市计算机学会" style="height:60px; width:60px"></td><td><h2 class="text-primary font-bolder" style="color:#2640a0">沈阳市计算机学会</h2></td></tr></tbody></table>
        </div>
      </a-col>
      <a-col :span="0" :sm="0" :md="18" :lg="12" style="padding: 20px">
        <a-input-search
          class="float-right"
          placeholder="请输入关键词搜索网站内容"
          enter-button="搜索"
          size="large"
          style="width:100%"
          @search="onSearch"
        />
      </a-col>
    </a-row>

    <!--nav-->
    <a-menu v-model="current"
            mode="horizontal"
            theme="light"
            @click="handleClick"
            style="color:var(--primaryColor); font-weight: bolder; font-size: larger">
      <a-sub-menu key="scf">
        <span slot="title"><span>关于SCF</span></span>
        <template v-for="item in societyList">
          <a-menu-item class="font-bold" :key="'society-'+ item.id">
            {{ item.name }}
          </a-menu-item>
        </template>
        <a-menu-item class="font-bold" key="events">
          大事记
        </a-menu-item>

      </a-sub-menu>

      <a-menu-item class="font-bold" key="news">
        新闻
      </a-menu-item>

      <!--      <a-menu-item class="font-bold" key="dynamic">-->
      <!--        活动动态-->
      <!--      </a-menu-item>-->
      <a-sub-menu key="member">
        <span slot="title"><span>会员</span></span>
        <template v-for="item in membersList">
          <a-menu-item class="font-bold" :key="'member-'+ item.id">
            {{ item.name }}
          </a-menu-item>
        </template>
        <a-menu-item class="font-bold">
          <router-link :to="{name:'register'}">申请会员</router-link>
        </a-menu-item>

      </a-sub-menu>

      <a-menu-item class="font-bold" key="activity">
        活动
      </a-menu-item>
      <!--      <a-menu-item class="font-bold" key="contact">-->
      <!--        联系我们-->
      <!--      </a-menu-item>-->
    </a-menu>
  </div>

</template>

<script>


import cookie from "../../../static/js/cookie";

export default {
  name: "logoNav",
  props: {
    membersList: Array,
    societyList: Array
  },
  data() {
    return {
      isLogin: cookie.getCookie('uid'),
      name: cookie.getCookie('name'),
      home: this.$route.name !== 'scf',
      current: [this.$route.path.split('/')[2]]
    }
  },

  watch: {
    $route(to, from) {
      if (to.name === 'scf') {
        this.current = ['']
        this.isLogin = cookie.getCookie('uid')
        this.home = false
      } else {
        this.home = true
      }
    }

  },
  computed: {
    toCenter() {
      var part = this.$store.getters.userInfo.part
      if (part === 'P') {
        return {name: 'center'}
      } else if (part === 'O') {
        return {name: 'orgCenter'}
      }
    }
  },
  mounted() {
  },
  methods: {
    onSearch() {
    },
    handleClick(e) {
      if (this.current[0] !== e.key) {
        if (e.key === 'center' || e.key === 'orgCenter') {
          this.current = ['']
        } else {
          this.current = [e.key]
        }
        let keys = e.key.split('-')

        if (keys.length > 1) {
          this.$router.push({name: keys[0], params: {id: keys[1]}})
        } else {
          this.$router.push({name: e.key})
        }


      }
    },
    onLogout({key}) {
      if (key === '2') {
        console.log(key)
        {
          cookie.delCookie('token')
          cookie.delCookie('name')
          cookie.delCookie('uid')
          cookie.delCookie('mid')
          cookie.delCookie('part')
          cookie.delCookie('id')

          this.$store.dispatch('setInfo');
          this.$store.dispatch('setPerson');
          this.$store.dispatch('setOrg');
          this.$store.dispatch('setUrl', '')
          //修改导航栏
          this.isLogin = false
          this.$router.push({name: 'scf'})
        }
        console.log(`退出按钮`);
        this.isLogin = false
      }

    },
  }
}
</script>

<style scoped>
.logo {
  width: 380px;
  height: 60px;
  margin: 10px 10px;
  float: left;
}

.header {
  background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/header/LogoNav.vue